<template>
  <div class="formGroup">
    <div class="quantity notranslate">
      <button type="button" class="btnQuantity" :disabled="Number(value.value) === quantity.min" @click.stop="dec">-</button>
      <input type="Number" class="inputQuantity" :placeholder="`${quantity.min} ~ ${quantity.max}`" :value="Number(value.value)" readonly>
      <button type="button" class="btnQuantity" :disabled="Number(value.value) === quantity.max" @click.stop="inc">+</button>
      <span v-if="message !== ''" class="message">{{message}}</span>
    </div>
    <div v-if="value.price" class="notranslate priceDpBoard price">
      {{priceFormat(value.price)}}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import regExp from '@/common/regExp'

export default {
  name: 'Quantity',
  props: [
    'id',
    'itemSetting',
    'currency',
    'storageData',
    'getSubmitData',
    'getPriceOption'
  ],
  computed: {
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    value: {
      get () {
        const data = typeof (this.getSubmitData.find(x => x.id === this.id)) === 'undefined' ? 0 : this.getSubmitData.find(x => x.id === this.id).value
        return data
      },
      set (value) {
        const data = {
          id: this.id,
          value: value
        }
        this.$emit('setValue', data)
      }
    },
    valueData () {
      return this.itemSetting.action
    },
    quantity () {
      return {
        min: Number(this.valueData.min),
        max: Number(this.valueData.max)
      }
    },
    priceInfo () {
      const sum = this.getPriceOption.reduce((a, b) => a + (b.quantity ? b.price * b.quantity : b.price), 0)
      const basePrice = Number(this.value.price)
      const total = (basePrice + sum) * this.value.value
      return {
        currency: this.currency.c,
        price: basePrice,
        quantity: this.value.value,
        sum: sum,
        total: total
      }
    }
  },
  watch: {
    priceInfo: {
      deep: true,
      handler (info) {
        this.$emit('setPriceInfo', info)
      }
    }
  },
  data () {
    return {
      message: ''
    }
  },
  mounted () {
    const isPrice = this.itemSetting.action.price.isPrice
    this.$emit('setHasPrice', isPrice)
  },
  methods: {
    dec () {
      if (this.value.value > this.quantity.min) {
        this.value.value--
      }
    },
    inc () {
      if (this.value.value < this.quantity.max) {
        this.value.value++
      }
    },
    displayPrice (price, needSymbol) {
      const result = regExp.comma(price)
      const symbol = price > 0 ? '+' : ''
      return needSymbol === true ? `${symbol}${result}` : result
    },
    getOptionPrice (option) {
      const price = option.quantity ? option.price * option.quantity : option.price
      return this.priceFormat(price)
    },
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    }
  }
}
</script>

<style lang="scss" scoped>
.calculate {
  .list {
    display: flex;
  }
  .label {
    margin-right: auto;
  }
  .price {
    margin-left: auto;
  }
}
.formGroup {
  .quantity {
  & + .price {
    font-size: 1.2em;
  }
}
}
</style>
